import { useMemo } from "react";
import type { Answer, ChatHistory } from "@/components/types";
import ConversationMessage from "./ConversationMessage";

interface ConversationListProps {
  messages?: Array<{ userQuestion: string; assistantAnswer: Answer }>;
  chatHistory?: ChatHistory[];
  onDocumentClick: (documentId: string) => void;
  isInitialMessage?: boolean;
  isFollowupMessages?: boolean;
}

const ConversationList = ({ 
  messages, 
  chatHistory, 
  onDocumentClick, 
  isInitialMessage = false,
  isFollowupMessages = false 
}: ConversationListProps) => {
  // Process followup messages from chat history
  const followupMessages = useMemo(() => {
    if (!chatHistory || !isFollowupMessages) return [];

    const followups = [];
    for (let i = 2; i < chatHistory.length; i += 2) {
      const userMessage = chatHistory[i];
      const assistantMessage = chatHistory[i + 1];
      
      if (userMessage && assistantMessage && 
          userMessage.role === "user" && 
          assistantMessage.role === "assistant" &&
          typeof assistantMessage.content === "object") {
        followups.push({
          userQuestion: userMessage.content as string,
          assistantAnswer: assistantMessage.content as Answer
        });
      }
    }
    return followups;
  }, [chatHistory, isFollowupMessages]);

  // Use provided messages or followup messages
  const messagesToRender = messages || followupMessages;

  if (!messagesToRender || messagesToRender.length === 0) {
    return null;
  }

  return (
    <div className="space-y-8">
      {messagesToRender.map((message, index) => (
        <ConversationMessage
          key={index}
          userQuestion={message.userQuestion}
          assistantAnswer={message.assistantAnswer}
          onDocumentClick={onDocumentClick}
          isFollowup={isFollowupMessages || (!isInitialMessage && index > 0)}
        />
      ))}
    </div>
  );
};

export default ConversationList;
